import { render, staticRenderFns } from "./ChangeTab.vue?vue&type=template&id=5669f519&scoped=true&"
import script from "./ChangeTab.vue?vue&type=script&lang=js&"
export * from "./ChangeTab.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTab.vue?vue&type=style&index=0&id=5669f519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669f519",
  null
  
)

export default component.exports